import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    // mode: 'hash',
	mode: 'history',
    routes: [{
        path: '/',
        name: 'home',
        component: () =>
            import ('@/components/module/home'),
        children: [{
			
            path: '/',
            name: 'Index',
            component: () =>
                import ('@/components/applicants/index'),
        },{
            path: '/indexEdit',
            name: 'IndexEdit',
            component: () =>
                import ('@/components/manager/indexEdit'),
        },{
            path: '/postgl',
            name: 'Postgl',
            component: () =>
                import ('@/components/manager/postgl'),
        },{
            path: '/manage',
            name: 'Manage',
            component: () =>
                import ('@/components/manager/manage'),
        },{
            path: '/datastatistics',
            name: 'Datastatistics',
            component: () =>
                import ('@/components/manager/datastatistics'),
        },{
            path: '/qyaccount',
            name: 'Qyaccount',
            component: () =>
                import ('@/components/manager/qyaccount'),
        },{
            path: '/viewlog',
            name: 'Viewlog',
            component: () =>
                import ('@/components/manager/viewlog'),
        },{
		    path: '/qyindex',
		    name: 'Qyindex',
		    component: () =>
		        import ('@/components/businusers/index'),
		},{
		    path: '/postajob',
		    name: 'Postajob',
		    component: () =>
		        import ('@/components/businusers/postajob'),
		},{
		    path: '/editcategory',
		    name: 'Editcategory',
		    component: () =>
		        import ('@/components/businusers/editcategory'),
		},{
        path: '/companyshow',
        name: 'Companyshow',
        component: () =>
            import ('@/components/businusers/companyshow'),
    },{
        path: '/companyedit',
        name: 'Companyedit',
        component: () =>
            import ('@/components/businusers/companyedit'),
    },{
		    path: '/campusshow',
		    name: 'Campusshow',
		    component: () =>
		        import ('@/components/businusers/campusshow'),
		},{
		    path: '/campusedit',
		    name: 'Campusdit',
		    component: () =>
		        import ('@/components/businusers/campusedit'),
		},{
		    path: '/myresumez',
		    name: 'Myresumez',
		    component: () =>
		        import ('@/components/applicants/myresumez'),
		},{
		    path: '/myfollow',
		    name: 'Myfollow',
		    component: () =>
		        import ('@/components/applicants/myfollow'),
		},{
		    path: '/mydelivery',
		    name: 'Mydelivery',
		    component: () =>
		        import ('@/components/applicants/mydelivery'),
		},{
		    path: '/mydeliverydetails',
		    name: 'Mydeliverydetails',
		    component: () =>
		        import ('@/components/applicants/mydeliverydetails'),
		},{
		    path: '/viewresume',
		    name: 'Viewresume',
		    component: () =>
		        import ('@/components/businusers/viewresume'),
		},{
		    path: '/viewresumeo',
		    name: 'Viewresumeo',
		    component: () =>
		        import ('@/components/businusers/viewresumeo'),
		},{
		    path: '/webpagepz',
		    name: 'Webpagepz',
		    component: () =>
		        import ('@/components/businusers/webpagepz'),
		},{
		    path: '/talentcommunity',
		    name: 'Talentcommunity',
		    component: () =>
		        import ('@/components/businusers/talentcommunity'),
		},{
		    path: '/seeconcerns',
		    name: 'Seeconcerns',
		    component: () =>
		        import ('@/components/businusers/seeconcerns'),
		},{
		    path: '/seeapplication',
		    name: 'Seeapplication',
		    component: () =>
		        import ('@/components/businusers/seeapplication'),
		},{
		    path: '/socialrecruitment',
		    name: 'Socialrecruitment',
		    component: () =>
		        import ('@/components/businusers/socialrecruitment'),
		}],
        redirect: '/index'
    },{ //刷新的页面
        path: '/refresh',
        name: 'Refresh',
        component: () =>
            import ('@/components/module/refresh/refresh'),
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js